import { render, staticRenderFns } from "./gocco-facets-header.vue?vue&type=template&id=7364681d&"
import script from "./gocco-facets-header.vue?vue&type=script&lang=ts&"
export * from "./gocco-facets-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports